import { lazy } from "react";

const AllAssets = lazy(() => import("../../../pages/User/assets/AllAssets"));
const ViewAsset = lazy(() => import("../../../pages/User/assets/ViewAsset"));
const AssetEditPage = lazy(() =>
  import("../../../pages/User/assets/EditAsset")
);
const NewAsset = lazy(() => import("../../../pages/User/assets/NewAsset"));
import { newAssetLoader } from "./assetLoader";
export const assetRoutes = [
  { path: "assets/:cat", element: <AllAssets /> },
  { path: "assets/:cat/:id/view", element: <ViewAsset /> },
  { path: "assets/:cat/:id/edit", element: <AssetEditPage /> },
  { path: "list/:type", element: <NewAsset />, loader: newAssetLoader },
];
